module.exports = __webpack_public_path__ + "static/INVSELANG-523cab2c77033f55777d2ddd47bf0d79.png";